/* @flow */
import React from 'react';
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import './styles/BoxBody.scss';

class BoxBody extends React.Component {
  static propTypes = {
    divided: React.PropTypes.bool,
    size: React.PropTypes.oneOf(['small', 'medium']),
    full: React.PropTypes.bool,
    title: React.PropTypes.string,
  };

  static propClasses = {
    divided: 'BoxBody-divided',
    size: {
      small: 'BoxBody-small',
    },
    full: 'BoxBody-full',
  };

  static defaultProps = {
    divided: false,
    size: 'medium',
    full: false,
  };

  render() {
    return (
      <div className={cx('BoxBody', getPropClassesFromInstance(this), this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default BoxBody;



// WEBPACK FOOTER //
// ./src/components/BoxBody.jsx